function showOpenPriceProductModal(productButton) {
    if ($('#priceModal').length === 0) {
        const modalHTML = `
        <div class="modal" id="priceModal" tabindex="-1" aria-labelledby="priceModalLabel" aria-hidden="true">
            <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                <h5 class="modal-title" id="priceModalLabel">Angi produktpris</h5>
                </div>
                <div class="modal-body">
                <div class="mb-3">
                    <label for="open-price-input" class="form-label">Pris</label>
                    <input type="text" inputmode="decimal" pattern="[0-9]*" class="form-control" id="open-price-input" placeholder="Skriv inn pris">
                </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Avbryt</button>
                    <button type="button" class="btn btn-primary" id="confirm-set-price">Bekreft</button>
                </div>
            </div>
            </div>
        </div>
        `;
        $('body').append(modalHTML);
    }

    $('#open-price-input').val('');

    $('#priceModal').off('shown.bs.modal');

    // Set up the focus event BEFORE showing the modal
    $('#priceModal').on('shown.bs.modal', function() {
        $('#open-price-input').focus();
    });

    // Show the modal
    $("#priceModal").modal("show");

    $('#confirm-set-price').off('click').on('click', function() {
        const price = parseFloat($('#open-price-input').val().replace(',', '.'));

        if (!isNaN(price) && price >= 0) {
            // Set the entered price on the button's data attributes for use in the add logic
            productButton.attr("data-price-incl-vat", price.toFixed(2));
            // Assuming alter price should match the entered price; adjust if alter is calculated differently
            productButton.attr("data-alter-price-incl-vat", price.toFixed(2));

            // Temporarily disable the open-price flag to bypass the modal check in the click handler
            const productContainer = productButton.closest(".shop-product-container");
            const originalOpenPriceFlag = productContainer.attr("data-is-open-price");
            productContainer.attr("data-is-open-price", 0);

            $('#openPriceValue').text(price.toFixed(2));
            $("#priceModal").modal("hide");

            // Trigger the original click handler now that the flag is temporarily disabled
            productButton.click();

            // Restore the original open-price flag
            productContainer.attr("data-is-open-price", originalOpenPriceFlag);
        } else {
            alert('Vennligst skriv inn en gyldig pris');
        }
    });

    // Handle Enter key press
    $('#open-price-input').off('keypress').on('keypress', function(e) {
        if (e.which === 13) {
            $('#confirm-set-price').click();
        }
    });

    // Remove the incorrect event name - should be 'hidden.bs.modal'
    $("#priceModal").on('hidden.bs.modal', function () {
        $('#open-price-input').val('');
        setTimeout(function() {
            $("#priceModal").remove();
        }, 500);
    });
}